import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { StudentGuard } from './core/auth/guards/student.guard';
import { TutorGuard } from './core/auth/guards/tutor.guard';
import { StudentOrGuestGuard } from './core/auth/guards/studentOrGuest.guard';
import { FindTutorsComponent } from './modules/landing/find-tutors/find-tutors.component';
import { TutorProfileComponent } from './modules/landing/tutor-profile/tutor-profile.component';
import { RegisterComponent } from './modules/auth/register/register.component';
import { OtpComponent } from './modules/auth/otp/otp.component';
import { ForgetPasswordComponent } from './modules/auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { TutorOnboardingComponent } from './modules/tutor/tutor-onboarding/tutor-onboarding.component';
import { CONSTANTS } from './core/constants';
import { AboutTutorComponent } from './modules/tutor/tutor-onboarding/about-tutor/about-tutor.component';
import { TeachingComponent } from './modules/tutor/tutor-onboarding/teaching/teaching.component';
import { EducationsComponent } from './modules/tutor/tutor-onboarding/educations/educations.component';
import { ExperienceComponent } from './modules/tutor/tutor-onboarding/experience/experience.component';
import { AvailabilityComponent } from './modules/tutor/tutor-onboarding/availability/availability.component';
import { RatePerHourComponent } from './modules/tutor/tutor-onboarding/rate-per-hour/rate-per-hour.component';
import { TAndCComponent } from './modules/tutor/tutor-onboarding/t-and-c/t-and-c.component';
import { LanguagesComponent } from './modules/tutor/tutor-onboarding/languages/languages.component';
import { ThankYouComponent as TutorThankYouComponent } from './modules/tutor/thank-you/thank-you.component';
import { NotFoundComponent } from './modules/landing/not-found/not-found.component';

export const routes: Routes = [
    // { path: '', pathMatch: 'full', redirectTo: 'example' },

    // Auth routes for guests
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NoAuthGuard],
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NoAuthGuard]
    },
    {
        path: 'forget-password',
        component: ForgetPasswordComponent,
        canActivate: [NoAuthGuard]
    },
    {
        path: 'verify-otp',
        component: OtpComponent,
        canActivate: [NoAuthGuard]
    },
    {
        path: 'otp',
        redirectTo: 'verify-otp',
        pathMatch: 'full'
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [NoAuthGuard]
    },
    {
        path: '',
        loadChildren: () => import('./modules/landing/landing.routes').then(m => m.default),
        canActivate: [NoAuthGuard],
    }, {
        path: 'student',
        loadChildren: () => import('./modules/student/student.routes').then(m => m.default),
        canActivate: [AuthGuard, StudentGuard],
    }, {
        path: 'bookings',
        loadChildren: () => import('./modules/bookings/bookings.routes').then(m => m.default),
        canActivate: [AuthGuard, StudentGuard],
    }, {
        path: 'tutor',
        loadChildren: () => import('./modules/tutor/tutor.routes').then(m => m.default),
        canActivate: [AuthGuard, TutorGuard],
    },
    {
        path: 'classroom/:id',
        loadComponent: () => import('./modules/classroom/classroom.component').then(m => m.ClassroomComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'thank-you',
        canActivate: [TutorGuard],
        component: TutorThankYouComponent
    },
    {
        path: 'tutor-signup',
        component: TutorOnboardingComponent,
        canActivate: [TutorGuard],
        children: [
            {
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            },
            {
                path: CONSTANTS?.tutorAboutUrl,
                component: AboutTutorComponent
            },
            {
                path: CONSTANTS?.tutorSubjectsUrl,
                component: TeachingComponent
            },
            {
                path: CONSTANTS?.tutorLanguagesUrl,
                component: LanguagesComponent
            },
            {
                path: CONSTANTS?.tutorEducationUrl,
                component: EducationsComponent
            },
            {
                path: CONSTANTS?.tutorExperienceUrl,
                component: ExperienceComponent
            },
            {
                path: CONSTANTS?.tutorAvailibilityUrl,
                component: AvailabilityComponent
            },
            {
                path: CONSTANTS?.tutorRatPerHourUrl,
                component: RatePerHourComponent
            },
            {
                path: CONSTANTS?.tutorSubmitUrl,
                component: TAndCComponent
            },
        ]
    },
    {
        path: 'find-tutors',
        component: FindTutorsComponent,
        canActivate: [StudentOrGuestGuard]
    },
    {
        path: 'find-tutors/:id',
        component: TutorProfileComponent,
        canActivate: [StudentOrGuestGuard]
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: '**',
        redirectTo: '404',
    },
];
